import { render } from "./PreventFallbackLanguageModal.vue?vue&type=template&id=9578b314"
import script from "./PreventFallbackLanguageModal.vue?vue&type=script&lang=js"
export * from "./PreventFallbackLanguageModal.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "9578b314"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9578b314', script)) {
    api.reload('9578b314', script)
  }
  
  module.hot.accept("./PreventFallbackLanguageModal.vue?vue&type=template&id=9578b314", () => {
    api.rerender('9578b314', render)
  })

}

script.__file = "resources/js/Modals/PreventFallbackLanguageModal.vue"

export default script